import * as Camera from "./camera";

import { Engine } from "babylonjs";
import store from "./store";

function create() {
  const engine = new Engine(
    store.canvas,
    true,
    {
      preserveDrawingBuffer: true,
      stencil: true
    },
    true
  );

  store.engine = engine;

  return engine;
}

function awake() {
  // run the render loop
  store.engine.runRenderLoop(function() {
    tick();
  });

  // the canvas/window resize event handler
  window.addEventListener("resize", function() {
    store.engine.resize();
  });
}

function tick() {
  store.scene.render();

  Camera.tick();

  lateTick();
}

function lateTick() {}

export { awake, create };
